export function get(user, flag, fallback = 0) {
  if (!user.usageLimits) {
    return fallback;
  }

  return user.usageLimits[flag];
}